import { api, pickDto } from '@/shared/api';
import * as Api from '@synapex/shared2/gateway-rest-api';
import { SnakeIdObj } from '@synapex/tools/typescript';

export const createInvite = (
  { advertiser_account_id }: SnakeIdObj<'advertiser_account'>,
  input: Api.AdvertiserAccount.User.CreateInviteInputDto,
) => {
  return api.post<Api.AdvertiserAccount.User.InviteReply>(
    `/advertiser-account/${advertiser_account_id}/invites`,
    pickDto(Api.AdvertiserAccount.User.CreateInviteInputDto, input),
  );
};
